import type { SportFilter } from '../../api/keys';
import { formatSigned } from '../../lib/format';
import { dayLoad, loadLabel, type HistoryDay } from './fitnessChartOption';

// The chart's screen-reader alternative, so it reads the filtered sport's Load as the bars do.
export function FitnessDataTable({ days, sport = 'all' }: { days: HistoryDay[]; sport?: SportFilter }) {
  const rows = days.map((day) => ({ day, load: dayLoad(day, sport) })).filter(({ load }) => load > 0);
  return (
    <table className="sr-only">
      <caption>Daily load</caption>
      <thead>
        <tr><th scope="col">Date</th><th scope="col">{sport === 'all' ? 'Load' : loadLabel(sport)}</th><th scope="col">Fitness</th><th scope="col">Fatigue</th><th scope="col">Form</th></tr>
      </thead>
      <tbody>
        {rows.map(({ day, load }) => (
          <tr key={day.date}>
            <th scope="row">{day.date}</th>
            <td>{Math.round(load)}</td>
            <td>{Math.round(day.fitness)}</td>
            <td>{Math.round(day.fatigue)}</td>
            <td>{formatSigned(day.form)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
